module.exports = __webpack_public_path__ + "static/media/5.2b3d1f64.jpg";